import React from 'react';

const WhyChooseSection = () => {
  return (
    <section className="why-choose section py-5" style={{ backgroundColor: 'bg-bluee' }}>
      <div className="container">
        {/* Section Title */}
        <div className="row mb-5 text-center">
          <div className="col-lg-12">
            <div className="section-title">
              <h2 className="display-4 font-weight-bold text-dark" style={{ fontSize: '2.5rem', marginBottom: '20px' }}>
                We Offer Different Services To Improve Your Health
              </h2>
              <img
                src="img/section-img.png"
                alt="Section Image"
                className="img-fluid my-4"
                style={{ maxWidth: '100%', borderRadius: '8px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}
              />
              {/* Optional Paragraph */}
              {/* <p className="lead text-muted">
                Wallabies Warm Care is the leading producer and supplier of forced air-warming systems and forced air-warming blankets. We take pride in serving society with quality products.
              </p> */}
            </div>
          </div>
        </div>

        {/* Who We Are and YouTube Video */}
        <div className="row">
          <div className="col-lg-6 col-12">
            {/* Who We Are */}
            <div className="choose-left">
              <h3 className="h4 font-weight-bold text-dark mb-4">Who We Are</h3>
              <p className="text-muted mb-4">
                Wallabies Warm Care is the leading producer and supplier of forced air-warming systems and forced air-warming blankets. We take pride in serving society with quality products. Our products are designed to meet the specific requirements of patients, and we prioritize their complete comfort while designing our systems. The appreciation we receive from our customers is a constant source of motivation for us.
              </p>
              <p className="text-muted mb-4">
                The biggest advantage of our business is that we are able to serve patients in a meaningful way, which provides immense satisfaction. We take great pride in offering the highest standard of care with every product we design.
              </p>

              <div className="row">
                <div className="col-lg-6">
                  <ul className="list-unstyled">
                    <li>
                      <i className="fa fa-caret-right mr-2" style={{ color: '#1A76D1' }}></i> We are the leaders in forced air-warming systems and blankets.
                    </li>
                    <li>
                      <i className="fa fa-caret-right mr-2" style={{ color: '#1A76D1' }}></i> Our products are designed with patient comfort in mind.
                    </li>
                    <li>
                      <i className="fa fa-caret-right mr-2" style={{ color: '#1A76D1' }}></i> Our customer feedback drives continuous improvement.
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <ul className="list-unstyled">
                    <li>
                      <i className="fa fa-caret-right mr-2" style={{ color: '#1A76D1' }}></i> We provide solutions tailored to specific medical needs.
                    </li>
                    <li>
                      <i className="fa fa-caret-right mr-2" style={{ color: '#1A76D1' }}></i> We are proud to improve patient outcomes through our products.
                    </li>
                    <li>
                      <i className="fa fa-caret-right mr-2" style={{ color: '#1A76D1' }}></i> Our mission is to ensure patients are kept warm and comfortable during medical procedures.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* YouTube Video */}
          <div className="col-lg-6 col-12">
            <div className="youtube-embed align-items-center">
              <iframe
                width="100%"
                height="415"
                src="https://www.youtube.com/embed/1BBc5QHVZYI?si=gIVC3SptRcK93TMZ&loop=1&playlist=1BBc5QHVZYI"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                style={{ borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
